import { render, staticRenderFns } from "./UnivariatePlots.vue?vue&type=template&id=6e90394f&scoped=true&"
import script from "./UnivariatePlots.vue?vue&type=script&lang=js&"
export * from "./UnivariatePlots.vue?vue&type=script&lang=js&"
import style0 from "./UnivariatePlots.vue?vue&type=style&index=0&id=6e90394f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e90394f",
  null
  
)

export default component.exports